import { useMemo } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { useClinicMedicalSpecialty } from './useClinicMedicalSpecialty';
import { usePlansEnabled } from './usePlansEnabled';
import { config as envConfig } from '../config/environment';
import {
  buildNavigationCatalog,
  type NavCatalogEntry,
} from '../navigation/appNavigationCatalog';
import {
  canAccessWhatsAppConfig,
  professionalCanAccessDynamicInboxFromUser,
  userCanAccessInventoryModule,
} from '../config/permissions';
import { isFisioterapiaClinic } from '../constants/appointmentTypes';

export function useAppNavigationCatalog(inboxEntries: Array<{ text: string; path: string }> = []): NavCatalogEntry[] {
  const { user, hasPermission } = useAuth();
  const { specialty } = useClinicMedicalSpecialty();
  const { plansEnabled } = usePlansEnabled();

  return useMemo(() => {
    const userRole = user?.role || 'admin';
    return buildNavigationCatalog({
      userRole,
      hasPermission,
      isFisioterapia: isFisioterapiaClinic(specialty),
      isOdontologia: String(specialty || '').trim().toLowerCase() === 'odontologia',
      plansEnabled,
      inventoryModuleEnabled: Boolean(user && userCanAccessInventoryModule(user)),
      platformAdminEnabled: Boolean(envConfig.platformAdminEnabled),
      whatsappConfigVisible: canAccessWhatsAppConfig(userRole, user?.current_unit),
      inboxEntries,
      professionalDynamicInbox: professionalCanAccessDynamicInboxFromUser(user),
    });
  }, [hasPermission, inboxEntries, plansEnabled, specialty, user]);
}
